var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugeiconsAiGenerative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15C15.5725 15 10.8575 15 7.93 17.93C5.0025 20.86 5 25.5725 5 35C5 44.4275 5 49.1425 7.93 52.07C10.86 54.9975 15.5725 55 25 55H35C44.4275 55 49.1425 55 52.07 52.07C54.9975 49.14 55 44.4275 55 35C55 32.075 55 29.605 54.9125 27.5",
    stroke: "#DC2418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 5L45.7375 6.9925C46.7025 9.6025 47.1875 10.9075 48.1375 11.86C49.0925 12.8125 50.3975 13.2975 53.0075 14.2625L55 15L53.0075 15.7375C50.3975 16.7025 49.0925 17.1875 48.14 18.1375C47.1875 19.0925 46.7025 20.3975 45.7375 23.0075L45 25L44.2625 23.0075C43.2975 20.3975 42.8125 19.0925 41.8625 18.14C40.9075 17.1875 39.6025 16.7025 36.9925 15.7375L35 15L36.9925 14.2625C39.6025 13.2975 40.9075 12.8125 41.86 11.8625C42.8125 10.9075 43.2975 9.6025 44.2625 6.9925L45 5Z",
    stroke: "#DC2418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsAiGenerative);
export default __webpack_public_path__ + "static/media/hugeiconsAiGenerative.f6124fec6415392d74234677fd567352.svg";
export { ForwardRef as ReactComponent };